import MainLogo from "../img/LogoO@2x.png";
import { useTranslation } from 'react-i18next';
import MainLogoPhone from "../img/LogoO@2x.png";
import { NavLink, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll"; 
import {
  ChevronDownIcon,
  CloseIcon,
  HamburgerIcon,
  MoonIcon,
  SunIcon,Portal
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Stack,
  useBreakpointValue,
  useColorMode,
  useDisclosure,
  useColorModeValue,Link
} from "@chakra-ui/react";

export default function Nav() {
  const mainColor = "#045846";
  const secColor = "#ed2224";

  const { isOpen, onClose, onOpen } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const { i18n, t } = useTranslation();
  const imageSrc = useBreakpointValue({ base: MainLogoPhone, md: MainLogo });
  const location = useLocation();
  const isHome = location.pathname === "/";

  const toggleLang = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.dir = newLang === "ar" ? "rtl" : "ltr";
  };

 const menuItems = [
  { label: t("navbar.home"), to: "hero" },
  { label: t("navbar.about"), to: "overview" },
  { label: t("navbar.visionMission"), to: "vision-mission" },
  { label: t("navbar.whyUs"), to: "why-easyvend" },
  { label: t("navbar.services"), to: "services" },
  { label: t("navbar.contact"), to: "contact" },
];
  

  return (
    <Box
      bg={isHome ? "transparent" : ("white")}
      position={isHome ? "absolute" : "relative"}
      top="0"
      left="0"
      w="100%"
      zIndex="1000"
      boxShadow={isHome ? "none" : "sm"}
      overflow={'hidden'}
    >
      <Container maxW="container.xl" py={2}>
        <Flex alignItems="center" justifyContent="space-between" overflow={'hidden'}>
          {/* Mobile Hamburger */}
          <IconButton
            aria-label="Toggle Menu"
            bg="none"
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            onClick={isOpen ? onClose : onOpen}
            display={{ base: "block", md: "none" }}
          />
          {/* Logo to: "hero"  */}
          <Flex align="center" mt={3}>
            <Image src={imageSrc} alt="Main logo" h={["40px","50px"]} />
          </Flex>
          {/* Desktop Menu */}
          <HStack as="nav" spacing={1} display={{ base: "none", md: "flex" }}>
            {menuItems.map((item) => (
             <ScrollLink
              to={item.to}
              smooth={true}
              duration={500}
              offset={-80} // adjust based on navbar height
            >
              <Button
                variant="ghost"
                fontWeight="medium"
                _hover={{ color: secColor }}
              >
                {item.label}
              </Button>
            </ScrollLink>
            ))}
             {/* Right Section */}
          <HStack spacing={10}>
            <Button size="md" onClick={toggleLang}>
              {i18n.language === "ar" ? "English" : "عربي"}
            </Button>
          </HStack>
          </HStack>

          {/* Right Section */}
          <HStack spacing={10} overflow={'hidden'}>
            <Button  display={{ base: "block", md: "none" }} size="md" onClick={toggleLang}>
              {i18n.language === "ar" ? "English" : "عربي"}
            </Button>
          </HStack>
        </Flex>

        {/* Mobile Menu Overlay */}
{isOpen && (
  <Portal>
    <Box
      bg="#fff"
      position="fixed"
      top="70px" // Adjust based on navbar height
      left="0"
      w="100%"
      py={4}
      px={4}
      boxShadow="lg"
      zIndex={9999}
    >
      <Stack spacing={4}>
        {menuItems.map((item) => (
          <ScrollLink
            key={item.to}
            to={item.to}
            smooth={true}
            duration={500}
            offset={-80}
            onClick={onClose}
          >
            <Button
              variant="ghost"
              fontWeight="medium"
              _hover={{ color: secColor }}
              width="100%"
            >
              {item.label}
            </Button>
          </ScrollLink>
        ))}
      </Stack>
    </Box>
  </Portal>
)}


      </Container>
    </Box>
  );
}